import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '../..'
import statementStore from '../statement-store'
import authStore from '../../auth/auth-store'
import setStatementQuery from './set-statement-query'
import feedStore from '../../feed/feed-store'

export default async function toggleIgnoredByMe(context: BareActionContext<StatementState, RootState>)
{
    const form = statementStore.state.statementSearchForm
    form.jybedByMe = false
    form.consideredByMe = false
    form.notReactedByMe = false

    setStatementQuery(context)

    return
}
